@if (env.preview) {
    <span (click)="addpageClicked()" class="fs-spa-button fs-spa-button-firstspirit">
        <span class="fs-spa-button-iconlabel">
            <span class="fs-spa-button-icon">
                <span class="fs-spa-icon-new"></span>
            </span>
            <span class="fs-spa-button-label">{{ label }}</span>
        </span>
    </span>
}
